export default {
  props: {
    amount: {
      type: [String, Number],
      default: ''
    }
  }
};
